/**
 * LevelCompleteOverlay - the end of a level, and the engine's offer.
 *
 * ---------------------------------------------------------------------------
 * AN OFFER IS AN OFFER
 *
 * Section 8.4 says a child at five successes out of five is OFFERED the next
 * level. ENGINE-BUILD.md section 3.6 is explicit that the game must not force
 * it. So "Next" appears here only when the engine has actually offered it; the
 * rest of the time the card offers another go, which is also what happens if
 * nobody touches the screen.
 *
 * Playing the same level again is not a consolation prize. A box needs ten
 * plays before it can be coloured at all (section 7.6), so a session that
 * advances the moment a level is finished never colours anything.
 */

export default function LevelCompleteOverlay({ card, onChoose }) {
  const offered = card.offer && card.offer.resolved;
  const stepBack = card.offer && card.offer.kind === 'back';

  return (
    <div className="bp-overlay" role="dialog" aria-label="Level complete">
      <div className="bp-overlay__card">
        <div className="bp-overlay__stars" aria-hidden="true">
          <span>⭐</span><span>⭐</span><span>⭐</span>
        </div>

        <h2 className="bp-overlay__title">All popped!</h2>
        <p className="bp-overlay__sub">
          Phase {card.phase}, level {card.level} · {card.progress.index + 1} of {card.progress.total} in this game
        </p>

        <div className="bp-overlay__actions">
          <button type="button" className="bp__btn bp__btn--primary" onClick={() => onChoose('again')}>
            Play again
          </button>

          {offered && !stepBack && (
            <button type="button" className="bp__btn" onClick={() => onChoose('next')}>
              Try the next one
            </button>
          )}

          {offered && stepBack && (
            <button type="button" className="bp__btn" onClick={() => onChoose('next')}>
              Go back one
            </button>
          )}

          <button type="button" className="bp__btn bp__btn--quiet" onClick={() => onChoose('end')}>
            Finish for now
          </button>
        </div>
      </div>
    </div>
  );
}
